// Exports
export default {
	"BroadcastViewerChat": "BroadcastViewerChat_waxOu",
	"BroadcastViewerChat_visible": "BroadcastViewerChat_visible_Tmmja",
	"BroadcastViewerChat__Wrapper": "BroadcastViewerChat__Wrapper_TxkMA",
	"BroadcastViewerChat__SpinWrapper": "BroadcastViewerChat__SpinWrapper_crqLy",
	"BroadcastViewerChat__Spin": "BroadcastViewerChat__Spin_rNDSY",
	"BroadcastViewerChat__Close": "BroadcastViewerChat__Close_g-FgL"
};
